/* Simply Trees redesigned product page behaviour. Scoped to [data-stp-hero]. */
(function () {
  var root = document.querySelector('[data-stp-hero]');
  if (!root) return;
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var moneyFmt = function (cents) {
    var d = cents / 100;
    return '$' + d.toLocaleString('en-US', { minimumFractionDigits: d % 1 ? 2 : 0, maximumFractionDigits: 2 });
  };

  /* toast */
  var toastEl = $('[data-stp-toast]'), tt;
  function toast(m) { if (!toastEl) return; toastEl.textContent = m; toastEl.classList.add('show'); clearTimeout(tt); tt = setTimeout(function () { toastEl.classList.remove('show'); }, 2600); }

  /* gallery */
  var slides = $('[data-stp-slides]');
  var n = slides ? slides.children.length : 0, cur = 0;
  function mark() {
    var c = $('[data-stp-counter]'); if (c) c.textContent = (cur + 1) + ' / ' + n;
    $$('[data-stp-thumbs] .stp-thumb').forEach(function (t, k) { t.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
    $$('[data-stp-dots] i').forEach(function (d, k) { d.classList.toggle('on', k === cur); });
  }
  function go(i) { if (!n) return; cur = (i + n) % n; slides.scrollTo({ left: slides.clientWidth * cur, behavior: 'smooth' }); mark(); }
  if (slides) {
    var p = $('[data-stp-prev]'), x = $('[data-stp-next]');
    if (p) p.addEventListener('click', function () { go(cur - 1); });
    if (x) x.addEventListener('click', function () { go(cur + 1); });
    var th = $('[data-stp-thumbs]');
    if (th) th.addEventListener('click', function (e) { var b = e.target.closest('.stp-thumb'); if (b) go(+b.dataset.i); });
    var st; slides.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(function () { var i = Math.round(slides.scrollLeft / slides.clientWidth); if (i !== cur) { cur = i; mark(); } }, 80); });
    slides.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') go(cur + 1); if (e.key === 'ArrowLeft') go(cur - 1); });
    var lb = $('#stp-lightbox');
    var openLB = function () { var img = slides.children[cur] && slides.children[cur].querySelector('img'); if (!img || !lb) return; var li = $('[data-stp-lb-img]', lb); li.src = img.currentSrc || img.src; li.alt = img.alt; openModal(lb); };
    slides.addEventListener('click', openLB);
    var z = $('[data-stp-zoom]'); if (z) z.addEventListener('click', openLB);
    mark();
  }

  /* modals */
  var lastFocus;
  function openModal(m) { lastFocus = document.activeElement; m.hidden = false; var c = m.querySelector('[data-stp-close]'); if (c) c.focus(); }
  function closeModal(m) { m.hidden = true; if (lastFocus) lastFocus.focus(); }
  $$('.stp-modal').forEach(function (m) {
    document.body.appendChild(m);
    m.addEventListener('click', function (e) { if (e.target === m || e.target.closest('[data-stp-close]')) closeModal(m); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') document.querySelectorAll('.stp-modal').forEach(function (m) { if (!m.hidden) closeModal(m); }); });
  $$('[data-stp-open]').forEach(function (b) { b.addEventListener('click', function () { var m = document.getElementById(b.dataset.stpOpen); if (m) openModal(m); }); });

  /* arrival video: swap poster for the YouTube player on click */
  var poster = $('[data-stp-video]');
  if (poster) poster.addEventListener('click', function () {
    var id = poster.dataset.stpVideo;
    poster.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&playsinline=1&rel=0" title="How your order arrives" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
  }, { once: true });

  /* chat buttons: open whichever chat widget is on the store, else follow the link */
  document.querySelectorAll('[data-stp-chat]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var w = window;
      try {
        if (w.GorgiasChat && w.GorgiasChat.open) { e.preventDefault(); w.GorgiasChat.open(); return; }
        if (w.tidioChatApi && w.tidioChatApi.open) { e.preventDefault(); w.tidioChatApi.open(); return; }
        if (w.zE) { e.preventDefault(); w.zE('messenger', 'open'); return; }
        var inbox = document.querySelector('inbox-online-store-chat');
        if (inbox && inbox.shadowRoot) { var btn = inbox.shadowRoot.querySelector('button'); if (btn) { e.preventDefault(); btn.click(); return; } }
      } catch (err) {}
    });
  });

  /* delivery estimate */
  var dEl = $('[data-stp-deliv]');
  if (dEl) {
    var fmt = function (d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); };
    var a = new Date(), b = new Date();
    a.setDate(a.getDate() + (+root.dataset.minDays || 6)); b.setDate(b.getDate() + (+root.dataset.maxDays || 9));
    dEl.textContent = fmt(a) + ' – ' + fmt(b);
  }

  /* zone check: uses the store's growzone finder (localStorage growzone_zone / growzone_zip) */
  var compat = (root.dataset.compatible || '').toLowerCase().split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  var zHead = $('[data-stp-zone-head]'), zBody = $('[data-stp-zone-body]'), zBtn = $('[data-stp-zonecard] .stp-link');
  var lastZone = null;
  function readZone() { try { var z = localStorage.getItem('growzone_zone'); if (!/^\d{1,2}[ab]?$/i.test(String(z || '').trim())) z = null; return { z: z, zip: localStorage.getItem('growzone_zip') }; } catch (e) { return {}; } }
  function renderZone() {
    var r = readZone(); var key = (r.z || '') + '|' + (r.zip || '');
    if (key === lastZone) return; lastZone = key;
    if (!r.z || !zHead) return;
    var z = String(r.z).toLowerCase(), num = parseInt(z, 10), where = 'Zone ' + r.z + (r.zip ? ' (' + r.zip + ')' : '');
    var valid = compat.length && compat.every(function (c) { return /^\d{1,2}[ab]?$/.test(c); });
    if (!valid) return;
    var outdoor = root.dataset.zoneMode === 'outdoor';
    var shop = null;
    if (zBtn) zBtn.hidden = false;
    if (compat.indexOf(z) > -1 || compat.some(function (c) { return parseInt(c, 10) === num && c.length <= 2; })) {
      zHead.textContent = 'Yes, it grows in ' + where + (outdoor ? '.' : '. In the ground or in a pot.'); zBody.textContent = root.dataset.groundMsg;
    } else if (outdoor) {
      zHead.textContent = "Heads up: it isn't rated for " + where + '.'; zBody.textContent = root.dataset.outMsg;
      if (num >= 1 && num <= 13) shop = num;
    } else if (num >= 4) {
      zHead.textContent = 'Yes, it grows in ' + where + '. Keep it in a pot.'; zBody.textContent = root.dataset.potMsg;
    } else {
      zHead.textContent = where + ' gets very cold.'; zBody.textContent = root.dataset.coldMsg;
      if (num >= 3) shop = num;
    }
    var old = $('[data-stp-zone-shop]'); if (old) old.remove();
    if (shop) {
      var a = document.createElement('a');
      a.className = 'stp-link'; a.setAttribute('data-stp-zone-shop', '');
      a.href = '/collections/all?filter.p.m.custom.usda_zone_filter=' + encodeURIComponent('Zone ' + shop) + '&sort_by=best-selling';
      a.textContent = 'Shop plants rated for Zone ' + shop + ' →';
      zBody.parentNode.insertBefore(a, zBody.nextSibling); zBody.parentNode.insertBefore(document.createTextNode(' '), a);
      if (zBtn) zBtn.hidden = true;
    } else if (zBtn) zBtn.textContent = 'Change ZIP';
  }
  renderZone();
  setInterval(renderZone, 1500);
  if (zBtn) zBtn.addEventListener('click', function () {
    var t = document.querySelector('.growzone-finder--toggler') || document.querySelector('.growzone-2--toggler');
    if (t) t.click(); else toast('Use the grow zone finder at the top of the page.');
  });

  /* variants, price, quantity */
  var variants = []; try { variants = JSON.parse($('[data-stp-variants]').textContent); } catch (e) {}
  var idInput = $('[data-stp-id]');
  var qtyInput = $('[data-stp-qty-input]');
  var atc = $('[data-stp-atc]'), atcText = $('[data-stp-atc-text]');
  function current() { var id = +idInput.value; for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i]; return variants[0]; }
  function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }
  /* site promo (e.g. Black Friday): sale price once the cart + this item reaches the promo minimum */
  var promo = null; try { promo = JSON.parse($('[data-stp-promo]').textContent); } catch (e) {}
  var promoCart = promo ? promo.cart : 0;
  function promoFor(v) {
    if (!promo || !v || Date.now() >= promo.ends) return null;
    var left = promo.min - (promoCart + v.price * qty());
    return { ok: left <= 0, left: left, sale: Math.round(v.price * (100 - promo.pct) / 100) };
  }
  function render() {
    var v = current(); if (!v) return;
    $$('.stp-size').forEach(function (b) { b.setAttribute('aria-pressed', +b.dataset.variant === v.id ? 'true' : 'false'); });
    var sl = $('[data-stp-size-label]'); if (sl) sl.textContent = v.title;
    var pp = promoFor(v), sale = pp && pp.ok;
    var unit = sale ? pp.sale : v.price;
    var pr = $('[data-stp-price]'); if (pr) pr.textContent = moneyFmt(unit);
    var wasVal = sale ? Math.max(v.price, v.compare_at_price || 0) : (v.compare_at_price > v.price ? v.compare_at_price : 0);
    var was = $('[data-stp-was]'); if (was) { was.hidden = !wasVal; was.textContent = wasVal ? moneyFmt(wasVal) : ''; }
    var box = $('[data-stp-pricebox]'); if (box) box.classList.toggle('is-sale', !!sale);
    var on = $('[data-stp-promo-on]'), off = $('[data-stp-promo-off]'), left = $('[data-stp-promo-left]');
    if (on) on.hidden = !sale;
    if (off) off.hidden = !pp || sale;
    if (left && pp && !sale) left.textContent = 'Add ' + moneyFmt(pp.left) + ' more to unlock it.';
    if (atc) { atc.disabled = !v.available; atcText.textContent = v.available ? 'Add to cart — ' + moneyFmt(unit * qty()) : 'Sold out'; }
    var ss = $('[data-stp-sticky-size]'), sp = $('[data-stp-sticky-price]');
    if (ss) ss.textContent = v.title; if (sp) sp.textContent = moneyFmt(unit);
    ladder();
  }
  $$('.stp-size').forEach(function (b) {
    b.addEventListener('click', function () {
      idInput.value = b.dataset.variant;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      try { history.replaceState({}, '', location.pathname + '?variant=' + b.dataset.variant); } catch (e) {}
      render();
    });
  });
  $$('[data-stp-qty]').forEach(function (b) { b.addEventListener('click', function () { qtyInput.value = Math.min(99, Math.max(1, qty() + (+b.dataset.stpQty))); render(); }); });
  if (qtyInput) qtyInput.addEventListener('input', render);

  /* buy more, save more: compact card (next goal + bar), full tier list folded away */
  var cartTotal = 0, cartItems = 0;
  function ladder() {
    var box = $('[data-stp-save]'); if (!box) return;
    var v = current(), add = v && v.available ? v.price * qty() : 0;
    var proj = cartTotal + add, items = cartItems + (v && v.available ? qty() : 0);
    var next = null, prev = 0, best = '';
    $$('.stp-tier', box).forEach(function (t) {
      var min = (+t.dataset.min || 0) * 100, need = +t.dataset.items || 0;
      var hit = need ? items >= need : proj >= min;
      t.classList.toggle('hit', hit);
      if (!need && min) {
        if (proj < min && (!next || min < next.min)) next = { min: min, offer: t.dataset.offer };
        if (proj >= min && min > prev) { prev = min; best = t.dataset.offer; }
      }
    });
    var big = $('[data-stp-save-big]', box), msg = $('[data-stp-prog-text]', box), bar = $('[data-stp-prog-bar]', box);
    var from = $('[data-stp-save-from]', box), to = $('[data-stp-save-to]', box);
    var lower = function (s) { return s.charAt(0).toLowerCase() + s.slice(1); };
    var b = function (s) { var e = document.createElement('b'); e.textContent = s; return e; };
    if (msg) {
      msg.textContent = '';
      msg.append(cartTotal ? 'Your cart with this item: ' : 'With this item: ', b(moneyFmt(proj)), '. ');
      if (next) msg.append('Add ', b(moneyFmt(next.min - proj)), ' more for ' + lower(next.offer) + '.');
      else msg.append("You've reached our biggest savings tier.");
    }
    if (big) big.textContent = next ? (best ? best + ' unlocked · next: ' + lower(next.offer) : next.offer + ' starts at ' + moneyFmt(next.min)) : "You've unlocked " + lower(best || 'our top savings');
    if (from) from.textContent = moneyFmt(prev);
    if (to) to.textContent = moneyFmt(next ? next.min : prev);
    if (bar) bar.style.width = (next ? Math.max(4, Math.min(100, (proj - prev) / (next.min - prev) * 100)) : 100) + '%';
  }
  fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { cartTotal = c.total_price || 0; cartItems = c.item_count || 0; if (promo) promoCart = (c.items || []).reduce(function (s, it) { return it.product_type === 'Membership' ? s : s + (it.original_line_price || 0); }, 0); render(); }).catch(function () {});
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-stp-code]'); if (!b) return;
    var code = b.dataset.stpCode;
    var done = function () { toast('Copied ' + code + '. It will also auto-apply at checkout.'); };
    try { navigator.clipboard.writeText(code).then(done, function () { toast('Your code: ' + code); }); } catch (err) { toast('Your code: ' + code); }
  });

  /* sticky bar: shows once the main Add to Cart scrolls away */
  var sticky = $('[data-stp-sticky]'), row = $('[data-stp-atcrow]');
  if (sticky && row && 'IntersectionObserver' in window) {
    document.body.appendChild(sticky);
    new IntersectionObserver(function (en) {
      var off = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      var v = current();
      sticky.classList.toggle('show', off && v && v.available);
      sticky.setAttribute('aria-hidden', off ? 'false' : 'true');
    }).observe(row);
    sticky.querySelector('[data-stp-sticky-atc]').addEventListener('click', function () { if (atc && !atc.disabled) atc.click(); });
  }

  /* desktop: let a tall buy box scroll fully, then pin its bottom edge */
  var buy = $('[data-stp-buy]');
  function pin() { if (!buy) return; if (innerWidth <= 900) { buy.style.top = ''; return; } buy.style.top = Math.min(20, innerHeight - buy.offsetHeight - 20) + 'px'; }
  addEventListener('resize', pin); if ('ResizeObserver' in window && buy) new ResizeObserver(pin).observe(buy); pin();

  render();
})();